import React from 'react';
import './styles/style.css';

const DangerButton = ({
  icon,
  text,
  onClick,
  disabled = false,
  type = 'button',
  size = 'M',
  className = '',
  ...props
}) => {
  const sizeClass = size === 'S' ? 'dangerButton--sm' : size === 'L' ? 'dangerButton--lg' : '';

  return (
    <button
      type={type}
      className={`dangerButton ${sizeClass} ${disabled ? 'disabled' : ''} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {icon && <div className="dangerButton-icon notranslate" translate="no">{icon}</div>}
      <div className="dangerButton-text">{text}</div>
    </button>
  );
};

export default DangerButton;